import './Logout.css'

const Logout = () => {
  return (
    <main className="logoutPage">
      <section className="logoutCard">
        <img className="logoutLogo" src="/logo_white_with_portal.png" alt="Sentosa Ship Brokers Portal" />
        <h1 className="logoutTitle">You've been logged out</h1>
        <p className="logoutSubtitle">Log in again whenever you're ready.</p>
        <a className="logoutButton" href={'/'}>
          Log in again
        </a>
      </section>
    </main>
  )
}

export default Logout
